import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useMemo } from 'react';
import { useStore, useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { useLocaleKeys } from '~/i18n';
import { sortAlphabetically } from '~/infra/utils';
import { relationshipSummaryModel } from '~/models';
import { selectors } from '~/store/state-selectors';
const SIGNED_AGREEMENT_STATUSES = new Set([
    'approved',
    'terminated'
]);
const SIGNED_SELECTABLE_STATUSES = [
    relationshipSummaryModel.AgreementStatus.Active,
    relationshipSummaryModel.AgreementStatus.Exhausted
];
const EMPTY_AGREEMENTS = [];
const toContactAgreements = (summaries)=>{
    var _summaries_find;
    const isSigned = (summary)=>SIGNED_AGREEMENT_STATUSES.has(summary.status);
    const adHocSummary = (_summaries_find = summaries.find((summary)=>!isSigned(summary))) !== null && _summaries_find !== void 0 ? _summaries_find : null;
    const signed = summaries.filter((summary)=>isSigned(summary) && summary.agreementStatusV2 != null && SIGNED_SELECTABLE_STATUSES.includes(summary.agreementStatusV2));
    const agreements = sortAlphabetically(signed.map((summary)=>({
            label: summary.title,
            value: summary.id
        })), 'label', {
        ascending: true,
        ignoreCase: true
    });
    return {
        agreements,
        adHocSummary
    };
};
export const useContactAgreements = (clientContactId)=>{
    const { api } = useStoreActions();
    const { t: globalBillModalTexts } = useLocaleKeys('components.globalBillModal');
    const businessId = useStore(selectors.user.businessId);
    const isVendor = useStore(selectors.user.isVendor);
    const { data, isLoading } = useQueryState({
        queryKey: [
            QueryKeys.ContactAgreements,
            businessId,
            clientContactId
        ],
        queryFn: ()=>api.relationship.getSummaries({
                businessId: businessId,
                isVendor,
                clientContactId,
                type: 'agreementAndAdHoc'
            }),
        enabled: businessId != null && clientContactId !== '',
        keepPreviousData: false,
        refreshOnHookMount: true,
        toasts: {
            errorMessage: globalBillModalTexts.failedToLoadAgreements(),
            errorTestId: 'agreements-request-error-toast'
        }
    });
    return useMemo(()=>_object_spread_props(_object_spread({}, data != null ? toContactAgreements(data) : {
            agreements: EMPTY_AGREEMENTS,
            adHocSummary: null
        }), {
            isLoading
        }), [
        data,
        isLoading
    ]);
};
